import type {
    RouteRecordRaw,
} from 'vue-router'

export default function (route: RouteRecordRaw, name: keyof RouteRecordRaw, defaultValue = '') {
    return (route.meta && route.meta[name]) || defaultValue
}
